import { toAbsoluteUrl } from "@/lib/utils/seo";

export const NEWS_LIST_PAGE_SIZE = 8 as const;

export function getNewsListCanonicalUrl(page: number, source: "all" | "ea" | "x" = "all") {
  const search = new URLSearchParams();
  if (page > 1) {
    search.set("page", String(page));
  }
  if (source !== "all") {
    search.set("source", source);
  }
  const query = search.toString();
  return toAbsoluteUrl(query ? `/news?${query}` : "/news");
}
